import { ImagesNoImagePlaceholderSvg } from '../assets/images.assets';
import isStringDefined from './is-string-defined';
import React, { useState } from 'react';
import Image, { ImageProps } from 'next/image';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export function getSkuMainImage(url?: string | null | undefined): string {
  const validUrl = isStringDefined(url) ? url : null;

  try {
    if (validUrl !== null) {
      new URL(validUrl);
      return validUrl;
    }
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error(error.message);
    }
    return ImagesNoImagePlaceholderSvg;
  }

  return ImagesNoImagePlaceholderSvg.src;
}

export function SkuMainImage(
  props: Omit<ImageProps, 'src'> & {
    src?: string | null | undefined;
  }
) {
  const { src, alt, ...restProps } = props;
  const fallbackSrc =
    'https://spiritory2storage.blob.core.windows.net/assets/No-Image-Placeholder.webp';

  return (
    <Image
      {...restProps}
      src={src && isStringDefined(src) ? src.trim() : fallbackSrc}
      alt={alt || 'Bottle image'}
      onError={e => {
        const target = e.target as HTMLImageElement;
        target.src = fallbackSrc;
      }}
    />
  );
}
